import type { SnakeToCamelObject, Tab } from '@browsing/api';

export enum ThbLinkType {
    CAMPAIGN = 'CAMPAIGN',
    TAB = 'TAB',
    URL = 'URL',
    NONE = 'NONE',
}

export type CategoryTab = SnakeToCamelObject<Tab>;

export type THB = CategoryTab['thb'];
